<template>
  <v-row class="main-visual">
    <v-col class="align-self-center">
      <span class="date">{{ todayTitle }}</span>
      <p class="desc">
        <strong class="name">
          {{ $store.getters.GET_USER_DATA.ssnName }}
        </strong>
        님!
        <br />
        <span>{{ welcomeMsg }}</span>
      </p>
    </v-col>
    <!-- v-col cols="7" sm="6" class="align-self-center mt4 pl-6">
      <p class="date">{{ todayTitle }}</p>
      <p class="desc">
        <strong class="name">
          {{ $store.getters.GET_USER_DATA.ssnName }}
        </strong>
        님!
        <br />
        즐거운 하루 보내세요
      </p>
      <출퇴근 기능 사용 여부 추가 필요 , 현재는 사용안함-->
    <!--
      <v-btn
        elevation="0"
        width="100%"
        class="btn-common"
        @click="clickInOutBtn()"
        :loading="isInit"
        :ripple="GET_LBS_FLAG"
        :class="{
          active: GET_LBS_FLAG,
          'btn-workOn': isIn,
          'btn-workOff': !isIn,
        }"
      >
        <span>
          <v-icon v-if="isIn">mdi-check</v-icon>
          <v-icon v-if="!isIn">mdi-logout</v-icon>
          {{ inOutBtnNm }}
        </span>
      </v-btn>

    </v-col>
    v-col cols="5" sm="6" class="text-end">
      <main-svg />
    </v-col-->
  </v-row>
</template>

<script>
/* 출퇴근카드 컴포넌트 */
//import MainSvg from '@/assets/customIcon/MainSvg.vue';
import { getWelcomeMsg } from '@/api/main';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
dayjs.locale('ko');

export default {
  props: {
    inOutInfo: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(['GET_LBS_FLAG', 'GET_LBS_TEST_DATA', 'GET_USER_DATA']),
    todayTitle() {
      return dayjs().format('M월 D일 dd요일');
    },
    // 최초 출퇴근버튼 초기화
    isInit() {
      return this.inOutInfo.inOutGubun === '';
    },
    // 출근여부
    isIn() {
      return this.inOutInfo.inOutGubun === '1';
    },
    inOutBtnNm() {
      return this.isIn ? '출근하기' : '퇴근하기';
    },
  },
  data: () => ({
    welcomeMsg: '',
  }),
  methods: {
    /* [출퇴근] 출퇴근 버튼클릭시 */
    clickInOutBtn() {
      if (!this.GET_LBS_FLAG) return false;
      if (confirm(`${this.isIn ? '출근' : '퇴근'} 처리하겠습니까?`)) {
        this.$emit('saveTimecard');
      }
    },

    async getWelcomeMsg() {
      const resData = await getWelcomeMsg();
      // console.log('getWelcomeMsg : ' + JSON.stringify(resData));
      // console.log('***************************');
      // console.log(resData.data.data.codeNm);
      // console.log('***************************');
  
      if(resData.data.data.codeNm !== '') {
        this.welcomeMsg = resData.data.data.codeNm;
      }else{
        this.welcomeMsg = '즐거운 하루 보내세요.';
      }
    },
  },
  //20240118 : 초기값 임의 설정
  created() {
    this.$store.commit('SET_LBS_FLAG', true);
    this.getWelcomeMsg();
  },
  mounted() {
  },
  components: {
    //MainSvg,
  },
};
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
